var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"attentReply"}},[_c('div',{staticClass:"contentIntroduce",attrs:{"id":"richText"},domProps:{"innerHTML":_vm._s(_vm.attentReply.CONTENT ? _vm.attentReply.CONTENT : '')}})]),_c('copy-right')],1)}
var staticRenderFns = []

export { render, staticRenderFns }